/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const BackofficeCardTxType2 = {
    STANDARD: 'STANDARD',
    TOP_UP: 'TOP_UP',
    CARD_CREDIT_REPAYMENT: 'CARD_CREDIT_REPAYMENT',
    UNKNOWN: 'UNKNOWN'
} as const;

export type BackofficeCardTxType2 = typeof BackofficeCardTxType2[keyof typeof BackofficeCardTxType2];



